import React from "react";

// Floating, subtle gold B9 logos that drift across the screen as you scroll.
// Fixed layer sits behind all section content (z-0) but above page bg.
const ITEMS = [
  { top: "12%", left: "6%",  size: 9,   delay: 0,   dur: 22, drift: "drift-a" },
  { top: "28%", left: "82%", size: 14,  delay: 4,   dur: 28, drift: "drift-b" },
  { top: "48%", left: "10%", size: 7,   delay: 2,   dur: 24, drift: "drift-c" },
  { top: "62%", left: "70%", size: 11,  delay: 6,   dur: 26, drift: "drift-a" },
  { top: "78%", left: "20%", size: 16,  delay: 1,   dur: 30, drift: "drift-b" },
  { top: "88%", left: "55%", size: 8,   delay: 5,   dur: 25, drift: "drift-c" },
  { top: "18%", left: "45%", size: 6,   delay: 7,   dur: 23, drift: "drift-b" },
  { top: "55%", left: "38%", size: 5,   delay: 3,   dur: 27, drift: "drift-a" },
];

export default function B9Background() {
  return (
    <div
      aria-hidden="true"
      data-testid="b9-background"
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
    >
      {ITEMS.map((it, i) => (
        <span
          key={i}
          className={`b9-float b9-float--${it.drift} b9-badge font-display absolute select-none`}
          style={{
            top: it.top,
            left: it.left,
            fontSize: `${it.size}rem`,
            animationDelay: `${it.delay}s, ${it.delay}s`,
            animationDuration: `${it.dur}s, 3.5s`,
          }}
        >
          B9
        </span>
      ))}
    </div>
  );
}
